import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=eb91e0d8&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=eb91e0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb91e0d8",
  null
  
)

export default component.exports